import { Component, EventEmitter, Input, OnInit, Output, signal } from '@angular/core';
import { AbstractComponent } from '../../abstract.component';
import { SolMarkdown } from '../../../models/core/sol-markdown';
import { SolContentComponent } from '../sol-content/sol-content.component';
import { SolContentMarkdownOptions, SolMarkdownFeatures } from '../../../tools/sol-content-markdown-tools';
import { NavigationTarget } from '../../../tools/router-tools';
import { SolContentLinkClickEvent } from '../../../models/core/sol-content';

@Component({
  selector: 'sol-markdown',
  imports: [SolContentComponent],
  templateUrl: './sol-markdown.component.html',
  host: { class: 'sol-markdown' },
})
export class SolMarkdownComponent extends AbstractComponent<SolMarkdown> implements OnInit {
  // Computed
  protected readonly content$ = this.compute(state => state.content);
  protected readonly linkTarget$ = this.compute(state => state.linkTarget);
  protected readonly linkClickObserved$ = signal(false);

  // Events
  @Output('linkClick')
  private readonly linkClickEmitter = new EventEmitter<SolContentLinkClickEvent>();

  constructor() {
    super(SolMarkdown.of());
  }

  public ngOnInit(): void {
    this.linkClickObserved$.set(this.linkClickEmitter.observed);
  }

  @Input()
  public set markdown(markdown: SolMarkdown) {
    this.patch(markdown);
  }

  @Input()
  public set text(text: string) {
    this.update(state => state.withText(text));
  }

  @Input()
  public set assetBasePath(assetBasePath: string | undefined) {
    this.update(state => state.withAssetBasePath(assetBasePath));
  }

  @Input()
  public set features(features: Partial<SolMarkdownFeatures> | undefined) {
    this.update(state => state.withFeatures(features));
  }

  @Input()
  public set imageResolver(imageResolver: SolContentMarkdownOptions['imageResolver']) {
    this.update(state => state.withImageResolver(imageResolver));
  }

  @Input()
  public set linkTarget(linkTarget: NavigationTarget) {
    this.update(state => state.withLinkTarget(linkTarget));
  }

  protected onLinkClick(event: SolContentLinkClickEvent): void {
    this.linkClickEmitter.emit(event);
  }
}
